export default __webpack_public_path__ + "1f68eed9b6416d8404f3daef02297630.png";